var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaystorelogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 23,
    viewBox: "0 0 21 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 23,
    fill: "url(#pattern0_1865_795)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_1865_795",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1865_795",
    transform: "scale(0.047619 0.0434783)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1865_795",
    width: 21,
    height: 23,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAXCAYAAADk3wSdAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAFaADAAQAAAABAAAAFwAAAABy20FuAAACo0lEQVQ4Eb2US0wTURiFz52Wh221LFRMJFEhiJEFsDCCTXwBalyoC2OiIRRjfGxcQAGNmqAJrty4cAExMRo2ooksrS5MfERijFSxhTZKjQtCgqGDLYWWtnP975TGKR1oUeM/mdyZ/57zzbkzNwNwboDfdRayYxP+URnhxnGgugeS/AIByYeC2E2Yb0/8DV8i8wY6JYT27UewoQaRfD8CHbfArxf+KVgCoyNZBD5Qi1DDB4C1Q571INB+Hvxc3krhIqm2CNxYh2D9IDVLaQE9CFiHKblNK8p2vRgq9CLxTkr8VjUzto2Sv0Ggsx/y5ZpswCRAXyUh2Fi7kDilOAGuDGGq0wn5UlWqqTfqJU3pkolnbK9TDXVkOEhwF6Y6blwbt1WkzS3cLAcVEgnTR+oQ3iXesaYYK+Ghw12hQTf34T73o1gzSaZsxWCEfHSHFrw+ER4am7pbZWSKkex2zMPPvejmY7AKXHaoUGnARUrU813urcxH4vdWYzCR5iri8PEv2C6B05FLEbhovL7A2+f8UcjjBUtYipHAaaO6+XPAWsMzn7ytzVstkS3m2Hz8Zd6xsT1pYI7PxOqiDTiQ0/LNkcior7W5zBKNWMAYm39Yvjv2uPzVAvQbrbUJFahiFRgQPfGily3L3JzX7WgpUYEpJYGjT8oqDaU/L0gnJ+8xhlhqSozLJjUngRvXhkOrNaZZKPwKPWSz4dRk72Kg0C2ZVCzZ42hZDOxnTGk1f3w2oXlIxqUuVAW22QVwjerg3CMllDOm4efvMgg6jQxoGpBgtDG6LS7nI/o/Kjp+3VYa1BSNjnja7CWUcJq+6EWzy9lHsBw2XDrbSBY1AQFH3Q67YV041GEK4gH7+jSaLl3JnYcfWvV+bnSk0X6HV+8tWon1v2p/Ade8/NrAO7kdAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaystorelogo);
export default __webpack_public_path__ + "static/media/playstorelogo.95e803f426a1fcfbaab1e603cf69186c.svg";
export { ForwardRef as ReactComponent };